(() => {
  'use strict';
  function initialise(scope) {
    scope.querySelectorAll('[data-ss-hero-products]').forEach(root => {
      if (root.dataset.gridBound) return;
      root.dataset.gridBound = 'true';
      const grid = root.querySelector('[data-ss-hero-grid]');
      const template = root.querySelector('[data-ss-hero-pool]');
      if (!grid || !template) return;
      const pool = Array.from(template.content.querySelectorAll('[data-ss-product]'));
      if (pool.length < 4) return;
      let previous = [];
      try { previous = JSON.parse(sessionStorage.getItem('ss-offer-hero-selection') || '[]'); } catch (_) {}
      for (let index = pool.length - 1; index > 0; index--) {
        const next = Math.floor(Math.random() * (index + 1));
        [pool[index], pool[next]] = [pool[next], pool[index]];
      }
      let selected = pool.slice(0, 4);
      if (pool.length > 4 && selected.every(item => previous.includes(item.dataset.ssProduct))) {
        selected[3] = pool.find(item => !previous.includes(item.dataset.ssProduct)) || pool[4];
      }
      grid.replaceChildren(...selected.map(item => {
        const tile = item.cloneNode(true);
        const image = tile.querySelector('img');
        if (image) image.loading = 'eager';
        return tile;
      }));
      try { sessionStorage.setItem('ss-offer-hero-selection', JSON.stringify(selected.map(item => item.dataset.ssProduct))); } catch (_) {}
    });
    scope.querySelectorAll('[data-ss-assurance]').forEach(root => {
      if (root.dataset.assuranceBound) return;
      root.dataset.assuranceBound = 'true';
      const buttons = Array.from(root.querySelectorAll('.ss-assurance-toggle'));
      const panels = Array.from(root.querySelectorAll('.ss-assurance-panel'));
      buttons.forEach(button => button.addEventListener('click', () => {
        const expand = button.getAttribute('aria-expanded') !== 'true';
        buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button && expand)));
        panels.forEach(panel => { panel.hidden = !(expand && panel.id === button.getAttribute('aria-controls')); });
      }));
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
